import { ApiOrgType } from 'api/types/ApiOrgType';

export const ORG_TYPES: ReadonlyArray<
  Readonly<{
    id: ApiOrgType;
    name: string;
    description?: string;
  }>
> = [
  {
    id: 'NONPROFIT',
    name:
      /* TRANSLATORS: org type */
      getText('Nonprofit'),
  },
  {
    id: 'COMMUNITY',
    name:
      /* TRANSLATORS: org type */
      getText('Community Group'),
    description:
      /* TRANSLATORS: Tooltip next to 'Community Group' label in organization type when creating new non-501c organization */
      getText(
        'Common interest and other mission-driven, noncommercial groups may now post listings that adhere to the Idealist guidelines.',
      ),
  },
  {
    id: 'RECRUITER',
    name:
      /* TRANSLATORS: org type */
      getText('Recruiter'),
  },
  {
    id: 'GOVERNMENT',
    name:
      /* TRANSLATORS: org type */
      getText('Government'),
  },
  {
    id: 'CORPORATION',
    name:
      /* TRANSLATORS: org type */
      getText('Business'),
    description:
      /* TRANSLATORS: Tooltip next to 'Business' label in organization type when creating new non-501c organization */
      getText(
        `Social enterprises and approved for-profit companies are allowed to post jobs on Idealist that adhere to our guidelines.`,
      ),
  },
  {
    id: 'CONSULTANT',
    name:
      /* TRANSLATORS: org type */
      getText('Consultant'),
  },
];
